import { Stethoscope } from 'lucide-react';

const ICON_SIZES = {
  sm: 'w-6 h-6 sm:w-7 sm:h-7',
  md: 'w-8 h-8',
  lg: 'w-9 h-9',
};

/**
 * Official VirtualScribe brand mark — matches homepage Navigation
 * (blue Stethoscope + gradient wordmark).
 */
export function VBotLogo({
  size = 'md',
  className = '',
  withWordmark = false,
  wordmarkClassName = '',
}) {
  const icon = ICON_SIZES[size] || ICON_SIZES.md;

  if (withWordmark) {
    return (
      <span
        className={`inline-flex items-center gap-2 font-bold tracking-tight ${className}`.trim()}
      >
        <Stethoscope className={`${icon} shrink-0 text-blue-600`} aria-hidden="true" />
        <span
          className={`leading-none bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent ${wordmarkClassName}`.trim()}
        >
          VirtualScribe
        </span>
      </span>
    );
  }

  return (
    <Stethoscope
      className={`${icon} text-blue-600 shrink-0 ${className}`.trim()}
      aria-hidden="true"
    />
  );
}

export default VBotLogo;